import React, { useContext, useEffect } from "react";
import { TranslatorContext } from "../../context/Translator";
import { useLocation } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { PaginationComponent } from "../../components";
import LabelFieldComponent from "../../components/fields/LabelFieldComponent";
import PageLayout from "../../layouts/PageLayout";
import { listUsers } from "../../APIs/UserRequests";
import { listUserTypes } from "../../APIs/UserTypeRequests";
import { ButtonComponent } from "../../components/elements";
import UsersTableComponent from "../../components/tables/UsersTableComponent";

export default function UsersManagementPage() {

    const { t } = useContext(TranslatorContext);
    const [users, setUsers] = React.useState([]);
    const [pagination, setPagination] = React.useState({});
    const [perPage, setPerPage] = React.useState(10);
    const [searchFilter, setSearchFilter] = React.useState('');
    const [userTypeFilter, setUserTypeFilter] = React.useState('');
    const [userTypes, setUserTypes] = React.useState([]);

    const location = useLocation();

    const listUsersFunction = (page=1) => {
        listUsers(page,perPage,searchFilter,userTypeFilter).then((res) => {
            setUsers(res.data.data);
            setPagination(res.data.pagination);
        }).catch((error) => {
            console.log(error);
        });
    }

    const listUserTypesFunction = () => {
        listUserTypes(1, 100).then((res) => {
            const userTypesData = res.data.data || [];
            setUserTypes(userTypesData);
        }).catch((error) => {
            console.log(error);
        });
    }

    useEffect(() => {
        listUsersFunction();
        listUserTypesFunction();
    }, [perPage,searchFilter,userTypeFilter,location]);
    const thead = [t("name"), t("email"),t("position"), t("status"), t("action")];

    const redirectToCreatePage = () => {
        window.location.href = '/user-account';
    };
    
    const handlePageClick = (selected) => {
        listUsersFunction(selected.selected + 1);
    }
    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">{t('users_list')}</h3>
                            {
                                localStorage.getItem('permissions').split(',').map(item => item.trim()).find(permission => permission === 'create user') && 
                                <ButtonComponent  className="btn btn-primary m-2" onClick={redirectToCreatePage}>{ t('Create New') }</ButtonComponent>                            

                            }
                        </div>
                    </div>
                </Col>
                
                <Col xl={12}>
                    <div className="mc-card">
                        
                        <Row xs={1} sm={2} xl={4}>
                            <Col>
                                <LabelFieldComponent
                                    label={t('show_by')}
                                    option={["10", "20", "50", "100"] }
                                    labelDir="label-col"
                                    fieldSize="w-100 h-md"
                                    onChange= {(e)=>{
                                        setPerPage(e.target.value);
                                    }}
                                />
                            </Col>
                            
                            <Col>
                                <LabelFieldComponent
                                    type="search"
                                    label={t('search_by')}
                                    placeholder={t('id') + ' / ' + t('name') + ' / ' + t('email') + ' / ' + t('number')}
                                    labelDir="label-col"
                                    fieldSize="w-100 h-md"
                                    onChange={(e) => {
                                            setSearchFilter(e.target.value);
                                    }}
                                />
                            </Col>

                            <Col>
                                <LabelFieldComponent
                                    label={t('filter_by_user_type') || 'Filter by User Type'}
                                    option={userTypes.map(userType => ({ name: userType.name, id: userType.id }))}
                                    labelDir="label-col"
                                    fieldSize="w-100 h-md"
                                    value={userTypeFilter}
                                    onChange={(e) => {
                                        setUserTypeFilter(e.target.value);
                                    }}
                                />
                            </Col>
                        </Row>
                        <UsersTableComponent 
                            thead={ thead }
                            tbody={ users }
                            refreshPage={ listUsersFunction }

                        />
                        <PaginationComponent pagination={pagination} handlePageClick={handlePageClick}/>
                    </div>
                </Col>
            </Row>
        </PageLayout>
    );
}